import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { ownerApi } from "@/lib/api";
import { money } from "@/lib/format";
import { Spinner } from "@/components/common/States";
import { cn } from "@/lib/utils";

export default function OwnerInsights() {
  const [period, setPeriod] = useState("30");
  const query = useQuery({ queryKey: ["ownerInsights", period], queryFn: () => ownerApi.getInsights(period) });
  const d = query.data;

  return (
    <div className="space-y-5">
      <div className="flex gap-2">
        {[["30", "30 days"], ["90", "90 days"], ["all", "All time"]].map(([p, l]) => (
          <button key={p} onClick={() => setPeriod(p)} className={cn("rounded-full px-4 py-1.5 text-xs font-semibold", period === p ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground")}>{l}</button>
        ))}
      </div>
      {query.isPending ? <Spinner /> : d ? (
        <>
          <div className="grid gap-3 sm:grid-cols-4">
            {[["Revenue", money(d.overview.revenue)], ["Orders", d.overview.orders], ["Avg order", money(d.overview.avg_order_value)], ["Repeat rate", `${Math.round(d.overview.repeat_customer_rate * 100)}%`]].map(([l, v]) => (
              <div key={l} className="rounded-2xl border border-border bg-card p-4"><p className="text-xs text-muted-foreground">{l}</p><p className="font-display text-xl font-bold">{v}</p></div>
            ))}
          </div>
          <div className="grid gap-6 lg:grid-cols-2">
            <div>
              <h3 className="mb-2 font-display text-sm font-bold">Top customers</h3>
              <div className="space-y-1.5">
                {d.top_customers.slice(0, 8).map((c) => (
                  <div key={c.phone} className="flex justify-between rounded-lg bg-secondary px-3 py-2 text-sm"><span>{c.name || c.phone}</span><span className="text-muted-foreground">{money(c.spend)} · {c.order_count}</span></div>
                ))}
              </div>
            </div>
            <div>
              <h3 className="mb-2 font-display text-sm font-bold">Win-back ({d.reengage.length})</h3>
              <div className="space-y-1.5">
                {d.reengage.slice(0, 8).map((c) => (
                  <div key={c.phone} className="flex items-center justify-between rounded-lg bg-secondary px-3 py-2 text-sm">
                    <span>{c.name || c.phone} <span className="text-xs text-muted-foreground">· {c.days_since_last_order}d ago</span></span>
                    <button onClick={() => ownerApi.sendReward(c.phone, d.reengage_reward_amount, "We miss you!").then(() => toast.success("Reward sent")).catch((e) => toast.error(e.message))} className="rounded-full bg-primary px-3 py-1 text-xs font-semibold text-primary-foreground">+{d.reengage_reward_amount}</button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}
